import React from 'react';
import PropTypes from 'prop-types';
import { SuiButton } from '@splashthat/sui';
import { Trash } from './RemoveButton.styles';

export default function RemoveButton({ onClick, ariaLabel }) {
    return <SuiButton variation="text" aria-label={ariaLabel} onClick={onClick} icon={<Trash />} />;
}

RemoveButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    ariaLabel: PropTypes.string.isRequired,
};
